var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LazyLoad from 'react-lazyload';
import { injectIntl } from '@s7ui-kit/s7ui-kit';
import getResizeImageUrl from '../../../../services/utils/getResizeImageUrl';
import { Declension } from '../../../../services/services/Declension';
import getCurrencyName from '../../../../services/utils/getCurrencyName';
import { analyticsMainPageBlockClick } from '../../../../services/analytics/analyticsMainpage';
import pushGA from '../../../../services/utils/pushGA';
import { CDN_PATH } from '../../../../constants/variables';
var DEFAULT_URL = "".concat(CDN_PATH, "S7PCabinService/media/by-path/raw/images/newmainpage/default-pic.jpg");
var SpecialOffersItem = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.offer, offer = _f === void 0 ? {
        deeplink: '',
        currency: 'RUB',
        dest: '',
        orig: '',
        destInfo: {},
        origInfo: {},
        imageUrl: DEFAULT_URL,
        price: 0,
        priceFormat: '',
        type: 'RT',
        extra: {}
    } : _f, _g = _a.index, index = _g === void 0 ? 1 : _g, _h = _a.priceUnknown, priceUnknown = _h === void 0 ? false : _h, _j = _a.personalized, personalized = _j === void 0 ? false : _j, props = __rest(_a, ["offer", "index", "priceUnknown", "personalized"]);
    var words = props.words, getMessage = props.getMessage;
    var declension = new Declension(words, getMessage);
    var orig = offer.orig, destInfo = offer.destInfo, origInfo = offer.origInfo, deeplink = offer.deeplink, imageUrl = offer.imageUrl, priceFormat = offer.priceFormat, price = offer.price, currency = offer.currency, type = offer.type, extra = offer.extra;
    var origIata = orig || (origInfo === null || origInfo === void 0 ? void 0 : origInfo.parentIata) || (origInfo === null || origInfo === void 0 ? void 0 : origInfo.iata);
    var destIata = offer.dest || ((_b = offer.destInfo) === null || _b === void 0 ? void 0 : _b.parentIata) || ((_c = offer.destInfo) === null || _c === void 0 ? void 0 : _c.iata);
    var onClick = function () {
        pushGA('PORTAL Offers', "".concat(personalized ? 'Personal' : 'Common', " GoToIBE"), "FROM:".concat(origIata, ";TO:").concat(destIata, ";TYPE:").concat(type), {
            eventValue: 0,
            eventInteraction: 0,
            eventUX: undefined,
            flightDetail: "RANK:".concat(extra === null || extra === void 0 ? void 0 : extra.rank)
        });
        analyticsMainPageBlockClick({
            step: 'special_offers',
            items: [{
                    item_id: destIata,
                    item_name: 'special_offers',
                    affiliation: 'content',
                    index: index + 1,
                    location_id: 's7_main'
                }]
        });
    };
    if (!((_d = offer.destInfo) === null || _d === void 0 ? void 0 : _d.city) || !((_e = offer.origInfo) === null || _e === void 0 ? void 0 : _e.city)) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement("a", { className: 'special-offers__item', href: "".concat(deeplink, "&CUR=").concat(currency, "&ibe_medium=s7PortalPersonalOffer_IBE"), onClick: onClick },
        React.createElement(LazyLoad, null,
            React.createElement("div", { className: 'special-offers__image', style: { backgroundImage: "url(".concat(getResizeImageUrl({ typeResize: 'resize', width: '160', height: '160', imageAbsoluteUrl: imageUrl })) } })),
        React.createElement("div", { className: 'special-offers__text-wrap' },
            React.createElement("p", { className: 'special-offers__to', dangerouslySetInnerHTML: {
                    __html: "".concat(destInfo.city)
                } }),
            React.createElement("p", { className: 'special-offers__from', dangerouslySetInnerHTML: {
                    __html: "".concat(getMessage(words, 'com.s7.generated.page.from'), " ").concat(declension.fromCity({ city: origInfo.city, iata: origIata }), " ").concat(getMessage(words, 'com.s7.main.page.special.offers.city.return'))
                } }),
            React.createElement("p", { className: 'special-offers__price' }, !!priceFormat && price > 0 && !priceUnknown ?
                "".concat(getMessage(words, 'com.s7.spec.fares.from'), " ").concat(priceFormat, " ").concat(getMessage(words, getCurrencyName(currency)))
                :
                    getMessage(words, 'com.s7.hermes.price.checkprice'))));
};
export default injectIntl(SpecialOffersItem);
